import React, { useEffect, useState } from 'react';
import Input from '@ui-library/input';
import { CronError, Cron } from 'react-js-cron';
import Button from '@ui-library/button';
import { parseExpression } from 'cron-parser';
import moment from 'moment';
import { ScheduleI } from '.';
import { ScheduleTypes } from '../scheduleTypes';
import classes from '../genericSettings.module.scss';

interface CronScheduleProps {
  expression?: string;
  onChange: (value: ScheduleI) => void;
  setInvalid: (isInvalid: boolean) => void;
}

const defaultCronExp = '0 0 * * *';
const CronSchedule = ({ expression, onChange, setInvalid }: CronScheduleProps) => {
  const cronValue = expression !== undefined ? expression : defaultCronExp;
  const customSetValue = (newValue: string) => {
    try {
      if (newValue) {
        const interval = parseExpression(newValue);
        const first = interval.next().toISOString();
        const second = interval.next().toISOString();
        const third = interval.next().toISOString();
        if (
          moment(second).diff(first, 'minutes') < 15 ||
          moment(third).diff(second, 'minutes') < 15
        ) {
          setFreqInvalid(true);
        } else {
          setFreqInvalid(false);
        }
      }
    } catch {
      setFreqInvalid(true);
    }

    const schedule: ScheduleI = {
      cron_expression: newValue,
      type: ScheduleTypes.Cron,
    };
    onChange(schedule);
  };

  const [error, onError] = useState<CronError>();
  const [isFreqInvalid, setFreqInvalid] = useState(false);
  useEffect(() => {
    onChange({ cron_expression: cronValue });
  }, []);

  useEffect(() => {
    setInvalid(Boolean(error?.description) || isFreqInvalid);
  }, [error?.description, isFreqInvalid]);
  return (
    <>
      <Input
        onChange={(event) => {
          customSetValue(event.target.value);
        }}
        value={cronValue}
        isError={Boolean(error?.description) || isFreqInvalid}
        errorMessage={
          error?.description ||
          (isFreqInvalid ? 'Sync frequency can not be less than 15 minutes' : '')
        }
        data-testid="cron_expression"
      />
      <div className={`m-b-xs m-t-md ${classes.cron__wrapper}`}>
        <Cron
          value={cronValue}
          setValue={customSetValue}
          onError={onError}
          clearButton={false}
          locale={{ suffixMinutesForHourPeriod: '', prefixMinutesForHourPeriod: 'at minute(s)' }}
        />
        <span>(UTC)</span>
      </div>
      <Button
        name="Reset"
        deleteOutlined
        onClick={() => {
          customSetValue(defaultCronExp);
        }}
      />
    </>
  );
};

export default CronSchedule;
